import config from '@/config';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import ImageCropper from './ImageCropper';

import './styles/PopupUpdateArtlistCover.css';

const PopupUpdateArtlistCover = ({ 
  open, 
  image, 
  exitCrop, 
  setCroppedFile,
  setCroppedUrl,
  cropShape 
}) => {
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';

  const isBlobURL = typeof image?.image_id === "string" && 
    (image.image_id.startsWith("blob:") || image.image_id.startsWith("data:image/"));

  const imageUrl = isBlobURL
    ? image.image_id
    : `${config.app.imageServiceDomain}/${image?.image_id}/brightness=0.8`;

  return (
    <GenericPopup
      open={open}
      className={`artlist-cover-crop-popup ${cropAreaClass}`}
    >
      <div className="artlist-cover__header">
        <p className="artlist-cover__header-text">
          Update Artlist Cover
        </p>
        <p className="artlist-cover__instructions">
          Adjust and crop your artlist cover
        </p>
      </div>
      <ImageCropper
        key={imageUrl}
        source={imageUrl}
        width={window.innerWidth}
        height={window.innerHeight}
        cropShape="rect"
        aspect={1}
        exitCrop={exitCrop}
        setCroppedFile={setCroppedFile}
        setCroppedUrl={setCroppedUrl}
      />
    </GenericPopup>
  );
};

export default PopupUpdateArtlistCover;
